<template>
	<div class="mx-auto p-0 sm:p-4">
		<div class="mx-auto">
			<div ref="detailsContent" id="detailsContent" class="text-gray-700">
				<div class="btn-grup flex justify-between items-start border-b no-print pb-2">
					<div class="flex w-full md:flex-nowrap flex-wrap">
						<!-- <div class="flex items-center" v-if="collectionModeData?.hideHeaderLanguageSwitch">
							<LanguageSwitcher class="mr-3 no-print"  :languages="languageList" :hideLabel="false" />

							<button
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white no-print"
								:class="{ 'rounded-e mr-2': !collectionModeData?.editmode }"
								type="button"
								v-if="!collectionModeData?.hidePostQuizButton"
								@click="modalVisiblePostQuiz = true"
							>
								<i class="tabler:list-details w-5 h-5 mr-1"></i>
								<span class="hidden md:inline">{{ labels.postquiz }}</span>
							</button>
							<EditButton
								v-if="collectionModeData?.editmode && post?._links.postQuiz?.href"
								class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
								:id="post?.identifier ?? ''"
								:type="collectionModeData?.id === 'language_review' ? 'lngReviewEdit' : 'postquiz'"
								:overrideURL="post?._links.postQuiz?.href"
						/>
						</div>						 -->
						<div class="audio-player relative no-print ml-auto">
							<EditButton
								v-if="collectionModeData?.editmode && collectionModeData?.id != 'language_review' && post?.file_url"
								class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-1 px-1 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all text-secondary !hover:text-white no-print z-2"
								:id="post?.identifier ?? ''"
								type="podcast"
								:overrideURL="post?._links?.podcastSlideshowConversations?.href"
							/>
							<SmallSoundPlayer v-if="post && post?.file_url" :jsonData="post" :language="selectedLanguage" :autoSuspend="false"
							/>
						</div>

					</div>

				</div>
				<DialogModal
					v-if="isModalPostQuiz"
					v-model:visible="modalVisiblePostQuiz"
					modal
					:header="labels.postquiz"
					:style="{ width: '40rem' }"
					:breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
				>
					<EditButton
						v-if="collectionModeData?.editmode"
						class="absolute right-53px top-[20px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
						:id="post?.identifier ?? ''"
						:type="collectionModeData?.id === 'language_review' ? 'lngReviewEdit' : 'postquiz'"
						:overrideURL="post?._links.postQuiz.href"
					/>
					<PostQuiz :jsonData="post" :modalVisiblePostQuiz="modalVisiblePostQuiz" :collectionMode='collectionModeData' @close="modalVisiblePostQuiz = false" />
				</DialogModal>
				<SliderPanel
					v-else
					v-model:visible="modalVisiblePostQuiz"
					:title="labels.postquiz"
					headerStyle="dark"
					size="xl"
					icon="tabler:list-check"
					:dismissable="false"
				>
					<div class="h-full overflow-y-auto p-4">
						<div v-if="collectionModeData?.editmode" class="mb-3 flex justify-end">
							<EditButton
								class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="post?.identifier ?? ''"
								:type="collectionModeData?.id === 'language_review' ? 'lngReviewEdit' : 'postquiz'"
								:overrideURL="post?._links.postQuiz.href"
							/>
						</div>
						<PostQuiz
							:jsonData="post"
							:modalVisiblePostQuiz="modalVisiblePostQuiz"
							:collectionMode="collectionModeData"
							@close="modalVisiblePostQuiz = false"
						/>
					</div>
				</SliderPanel>

				<DialogModal group="templating">
					<template #message="slotProps">
						<div class="flex flex-col items-center w-full gap-3 border-b-1 pb-3">
							<div
								class="border-rounded-50% border-primary w-50px h-50px border-3px flex items-center justify-center"
							>
								<i :class="slotProps.message.icon" class="text-3xl inline-block text-primary-500"></i>
							</div>
							<p class="text-sm text-gray-700">{{ slotProps.message.message }}</p>
						</div>
					</template>
				</DialogModal>

				<div class="">
					<EwLoadingOverlay v-if="loading" class="relative inset-0 z-50 flex items-center justify-center" />  
					
					<section id="section1" class="mb-8">
						<div class="flex justify-end py-3">
							<button
								type="button"
								class="flex flex-row items-center justify-center items-center text-center font-sans text-xs transition-all block md:hidden text-primary-500"
								@click="showGallery = !showGallery"
							>
								<i class="tabler:photo-up w-5 h-5"></i>
							</button>
							<div class="flex ml-auto no-print mb-3">
								<PrintButton />
							</div>

						</div>

						<div class="flex flex-row sm:flex-column justify-center px-4 flex-wrap" v-if="post">
							<div id="twoCol" v-if="post?.mainOutcome?.sectionLayout != 'oneCol'" class="flex flex-row sm:flex-column justify-center flex-wrap">
								<div class="pr-4 sm:w-4/12 md:w-4/12 lg:w-4/12 rounded-lg hidden sm:block">
									<div class="flex items-center gap-2 justify-end mb-3">
										<EditButton
											class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white no-print"
											type="newImage"
											v-if="collectionModeData?.editmode"
											:id="post?.identifier ?? ''"
											:overrideURL="post?._links.illustration.href"
										/>
										<EditButton
											class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
											v-if="collectionModeData?.editmode"
											:id="post?.identifier ?? ''"
											type="imagelist"
											:overrideURL="post?._links.illustration.href"
										/>
									</div>

									<div v-if="post?.illustration && post.illustration.length != 0 && post.mainOutcome.sectionLayout != 'oneCol'" class="relative">
										<ImageGallery :jsonData="post" :collectionModeData="collectionModeData"></ImageGallery>
									</div>
									<div v-else>
										<InteractiveImage alt="Image" preview>
											<template #indicatoricon>
												<i class="tabler:eye w-8 h-8 text-white"></i>
											</template>
											<template #image>
													<img
														v-if="!isImageError"
														:src="post?.mainOutcome.imageSrc"
														alt="image"
														@load="isImageLoaded = true"
														@error="isImageError = true"
														class="transition-opacity duration-300 !max-h-[720px]"
														:class="{ 'opacity-0': !isImageLoaded }"
													/>

													<div v-if="isImageError" class="text-red-500 text-sm">Image not available</div>
											</template>
											<template #preview="slotProps">
												<div class="p-5">
													<img
														:src="post?.mainOutcome.imageSrc"
														alt="preview"
														class="mx-auto"
														:style="slotProps.style"
														@click="slotProps.onClick"
													/>
													<p class="text-sm italic text-white mt-8 text-left">
														{{ post?.mainOutcome.imageTitle }}
													</p>
												</div>
											</template>
										</InteractiveImage>
										<div class="text-left italic text-sm">
											{{ post?.mainOutcome.imageTitle }}
										</div>
									</div>
								</div>
								<div class="md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1">
									<InplaceEdit
										:inputProps="[{ content: post?.mainOutcome?.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
										:href="post?._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true" :collectionMode="collectionModeData"
										:enableCollapseSection="true" :extraContent="post?.mainOutcomeBl.selectHeader">
										<h6
											class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
											{{ post?.mainOutcome.selectHeader }}
										</h6>
									</InplaceEdit>
									<div class="flex items-center">

												<InplaceEdit
													:inputProps="[
														{
															content: post?.mainOutcome.title,
															propName: 'title',
															inputType: 'textarea',
														},
													]"
													:href="post?._links.mainOutcomeEdit.href"
													:showAssistant="true"
													:enableCollapseSection="true"
													:extraContent="post?.mainOutcomeBl.title"
													:collectionMode="collectionModeData"
													blockTitle="Edit title"
													:textarea-props="{ rows: 3, class: 'min-w-[60rem]' }"
												>
													<h4
														class="my-2 !line-height-[1.2] flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased"
													>
														{{ post?.mainOutcome.title }}
													</h4>
												</InplaceEdit>
									</div>
									<div class="gap-3 flex items-center">
										<InplaceEdit
											v-if="collectionModeData?.id != 'language_review'"
											:collectionMode="collectionModeData"
											:inputProps="[
												{
													content: post?.mainOutcome.publishingDate,
													propName: 'other.publishingDate',
													inputType: 'datepicker',
												},
											]"
											:href="post?._links.mainOutcomeEdit.href"
											blockTitle="Edit publishing date"
										>
											<div class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated }}
											</div>
										</InplaceEdit>
										<div v-else class="text-sm inline-flex items-center pt-1 my-1">
											{{ publishingDateFormated }}
										</div>

										<InplaceEdit
											:collectionMode="collectionModeData"
											v-if="collectionModeData?.id != 'language_review'"
											:inputProps="[
												{
													content: post?.mainOutcome.authorIdentifier,
													propName: 'other.authorIdentifier',
													inputType: 'select',
													selectProps: {
														optionValue: 'identifier',
														optionLabel: 'title',
														class: 'w-15rem',
														optionsCvKey: 'author',
													},
												},
											]"
											:href="post?._links?.mainOutcomeEdit?.href || ''"
											blockTitle="Edit author"
										>
											<div class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
										</InplaceEdit>
										<div v-else class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
									</div>
									<div v-if="post?.mainOutcome.leadText" class="relative py-3">
										<strong class="mb-4">{{ labels.leadText }}</strong>
										<div id="editLeadText" class="flex items-end relative">
											<InplaceEdit
												:collectionMode="collectionModeData"
												:enableCollapseSection="true"
												:extraContent="post?.mainOutcomeBl.leadText"
												:inputProps="[{ content: post?.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
												:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit leadtext" :showAssistant="true">
												<div v-html="post?.mainOutcome.leadText"></div>
											</InplaceEdit>
										</div>
									</div>
									<div id="editKeyMessages" class="relative py-4" v-if="post?.mainOutcome.keyMessages">
										<h3 class="font-bold text-md mb-4">{{ labels.keymessages }}</h3>
										<!-- <EditButton
											v-if="collectionModeData?.editmode && post.identifier"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/> -->

										<div class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div id="editKeyMessagges" class="py-5 px-2">
														<InplaceEdit
															:collectionMode="collectionModeData"
															:enableCollapseSection="true"
															:extraContent="post?.mainOutcomeBl.keyMessages"
															:inputProps="[{ content: post?.mainOutcome.keyMessages, propName: 'other.keyMessages', inputType: 'editor' }]"
															:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit key Messages" :showAssistant="true">
															<div v-html="post?.mainOutcome.keyMessages"></div>
														</InplaceEdit>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="main-text relative">
										<div v-for="(section, index) in post?.mainOutcome.main_text" :key="index" >
											<InplaceEdit
												:collectionMode="collectionModeData"
												:enableCollapseSection="true"
												:extraContent="[
													post?.mainOutcomeBl?.main_text?.[index]?.heading ?? '',
													post?.mainOutcomeBl?.main_text?.[index]?.content ?? ''
												]"
												:inputProps="[
													{ content: section.heading, inputType: 'input', propName: 'heading' },
													{ content: section.content, inputType: 'editor', propName: 'content' },
												]"
												method="PUT"
												:href="section._links.self.href"
												blockTitle="Edit section"
												:showAssistant="true"
											>
												<div class="my-2">
													<div class="text-sm">
														<strong class="block text-gray-700">
															{{ section.heading }}
														</strong>
														<div v-html="section.content" class="text-gray-600"></div>
													</div>
												</div>
											</InplaceEdit>
											<!-- <div class="flex w-full flex-col">
												<template v-if="section.illustrations && section.illustrations.length > 0">
													<div class="flex align-items-center gap-4 my-4">
														<InteractiveImage class="w-[270px] overflow-hidden" alt="Image" preview>
															<template #indicatoricon>
																<i class="tabler:eye w-8 h-8 text-white"></i>
															</template>

															<template #image>
															
																<img
																	v-if="section.illustrations[0].imageSrc && section.illustrations[0].imageSrc !== '' && !hasSectionImageError(index)"
																	:src="section.illustrations[0].imageSrc"
																	alt="image"
																	@load="onSectionImageLoad(index)"
																	@error="onSectionImageError(index)"
																	class="transition-opacity duration-300 w-full h-auto max-w-[270px] object-contain"
																	:class="{ 'opacity-0': !isSectionImageLoaded(index) }"
																/>
																
																<div v-else class="text-gray-400 italic text-sm">No image available</div>
															</template>

															<template #preview="slotProps">
																<div class="p-5">
																	<img
																		v-if="section.illustrations[0].imageSrc && section.illustrations[0].imageSrc !== ''"
																		:src="section.illustrations[0].imageSrc"
																		alt="preview"
																		class="mx-auto"
																		:style="slotProps.style"
																		@click="slotProps.onClick"
																	/>
																	<p class="text-sm italic text-white mt-8 text-left">
																		{{ section.illustrations[0]?.imageTitle || '' }}
																	</p>
																</div>
															</template>
														</InteractiveImage>
														<div class="rounded bg-primary-50/20 p-3 flex flex-col gap-2 flex-1">
															<div class="text-left text-sm">
																<strong>{{labels.titleLabel}}</strong> {{ section.illustrations[0]?.imageTitle || '' }}
															</div>
															<div class="text-left text-sm">
																<strong>{{labels.descriptionLabel}}</strong> {{ section.illustrations[0]?.imageDescription || '' }}
															</div>
															<div class="text-left text-sm">
																<strong>{{labels.copyrightLabel}}</strong> {{ section.illustrations[0]?.imageCopyright || '' }}
															</div>
														</div>
													</div>
												</template>
											</div> -->
										</div>
									</div>
									<div class="relative mt-3 py-4" v-if="post?.mainOutcome.references && post.mainOutcome.references.length > 0" >
										<h3 class="font-bold text-md mb-4">{{ labels.referenceslabel }}</h3>
										<!-- <EditButton
											v-if="collectionModeData?.editmode && collectionModeData?.id != 'language_review'"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/> -->

										<div id="references" class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div
														class="py-5 px-2 mx-4"
													>
														<ol class="list-decimal">
															<li
																v-for="(referenceItem, index) in post?.mainOutcome
																	.references"
																:key="index"
																class="text-sm"
															>
															<div class="flex items-center py-1">
																	<InplaceEdit
																		:collectionMode="collectionModeData"
																		:inputProp="
																			{
																				content: referenceItem,
																				propName: 'other',
																				removeProps: ['pdfLink', '_links'],
																				inputType: 'references',
																			}
																		"
																		method="PUT"
																		:href="referenceItem._links?.self.href"
																		:showSwitch="true"
																		blockTitle="Edit Refrence"
																	>
																	
																		<span v-if="referenceItem.journal">
																			{{ referenceItem.journal }}
																		</span>
																		<span v-if="referenceItem.year">
																			{{ referenceItem.year }},
																		</span>

																		<span
																			v-if="
																				referenceItem.nameDOI || referenceItem.linkDOI
																			"
																			class="font-semibold"
																		>
																			{{ referenceItem.nameDOI ? 'DOI:' : 'Link:' }}
																			<a
																				:href="
																					referenceItem.nameDOI
																						? `https://doi.org/${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				"
																				target="_blank"
																				class="text-primary"
																			>
																				{{
																					referenceItem.nameDOI
																						? `${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				}}
																			</a>
																		</span>
																		<span
																			v-if="
																				(referenceItem.nameDOI ||
																					referenceItem.linkDOI) &&
																				referenceItem.title
																			"
																			>,
																		</span>
																		<span
																			v-if="referenceItem.title"
																			class="ml-1 font-semibold"
																			>&laquo;{{ referenceItem.title }}&raquo;</span>
																	</InplaceEdit>
																	<a v-if="referenceItem?.pdfLink" @click.prevent="openModal(index)" class="btn btn-outline-dark px-1 py-0 cursor-pointer no-print">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a>
																	<!-- <a v-if="referenceItem?.pdfLink" @click="openModal" class="btn btn-outline-dark px-1 py-0 cursor-pointer"  		:href="`/example/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a> -->
																	<!-- <iframe class="pdfViewer w-100 h-100" style="" :src="`/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`"></iframe> -->

																</div>
															</li>
														</ol>
													</div>
													<!-- <div v-else class="p-5 bg-gray-100 flex items-center">
														<div class="text-center text-danger text-xs inline-flex mx-auto">
															<i class="tabler:info-triangle w-5 h-5 mr-2"></i>{{labels.noReference}}
														</div>
													</div> -->
												</div>
											</div>
										</div>
									</div>
									<!-- <div class="relative no-print">
										<RatingItems :jsonData="post" :feedback-url="computedFeedbackUrl" :selectedLanguage="currentLng" @open-postquiz="modalVisiblePostQuiz = true" :collectionMode="collectionModeData" />
									</div> -->

								</div>
							</div>		
							<div id="oneCol" v-else class="flex flex-wrap">
								<div class="flex flex-row sm:flex-column justify-center flex-wrap">
									<div class="pr-4 sm:w-4/12 md:w-4/12 lg:w-4/12 rounded-lg hidden sm:block">
										<div class="flex items-center gap-2 justify-end mb-3">
											<EditButton
												class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white no-print"
												type="newImage"
												v-if="collectionModeData?.editmode"
												:id="post?.identifier ?? ''"
												:overrideURL="post?._links.illustration.href"
											/>
											<EditButton
												class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
												v-if="collectionModeData?.editmode"
												:id="post?.identifier ?? ''"
												type="imagelist"
												:overrideURL="post?._links.illustration.href"
											/>
										</div>

										<div>
											<InteractiveImage alt="Image" preview>
												<template #indicatoricon>
													<i class="tabler:eye w-8 h-8 text-white"></i>
												</template>
												<template #image>
														<img
															v-if="!isImageError"
															:src="post?.mainOutcome.imageSrc"
															alt="image"
															@load="isImageLoaded = true"
															@error="isImageError = true"
															class="transition-opacity duration-300 !max-h-[720px]"
															:class="{ 'opacity-0': !isImageLoaded }"
														/>

														<div v-if="isImageError" class="text-red-500 text-sm">Image not available</div>
												</template>
												<template #preview="slotProps">
													<div class="p-5">
														<img
															:src="post?.mainOutcome.imageSrc"
															alt="preview"
															class="mx-auto"
															:style="slotProps.style"
															@click="slotProps.onClick"
														/>
														<p class="text-sm italic text-white mt-8 text-left">
															{{ post?.mainOutcome.imageTitle }}
														</p>
													</div>
												</template>
											</InteractiveImage>
											<div class="text-left italic text-sm">
												{{ post?.mainOutcome.imageTitle }}
											</div>
										</div>
									</div>
									<div class="md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1">
										<InplaceEdit
											:inputProps="[{ content: post?.mainOutcome?.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
											:href="post?._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true" :collectionMode="collectionModeData"
											:enableCollapseSection="true" :extraContent="post?.mainOutcomeBl.selectHeader">
											<h6
												class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
												{{ post?.mainOutcome.selectHeader }}
											</h6>
										</InplaceEdit>
										<div class="flex items-center">

													<InplaceEdit
														:inputProps="[
															{
																content: post?.mainOutcome.title,
																propName: 'title',
																inputType: 'textarea',
															},
														]"
														:href="post?._links.mainOutcomeEdit.href"
														:showAssistant="true"
														:enableCollapseSection="true"
														:extraContent="post?.mainOutcomeBl.title"
														:collectionMode="collectionModeData"
														blockTitle="Edit title"
														:textarea-props="{ rows: 3, class: 'min-w-[60rem]' }"
													>
														<h4
															class="my-2 !line-height-[1.2] flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased"
														>
															{{ post?.mainOutcome.title }}
														</h4>
													</InplaceEdit>
										</div>
										<div class="gap-3 flex items-center">
											<InplaceEdit
												v-if="collectionModeData?.id != 'language_review'"
												:collectionMode="collectionModeData"
												:inputProps="[
													{
														content: post?.mainOutcome.publishingDate,
														propName: 'other.publishingDate',
														inputType: 'datepicker',
													},
												]"
												:href="post?._links.mainOutcomeEdit.href"
												blockTitle="Edit publishing date"
											>
												<div class="text-sm inline-flex items-center pt-1 my-1">
													{{ publishingDateFormated }}
												</div>
											</InplaceEdit>
											<div v-else class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated }}
											</div>

											<InplaceEdit
												:collectionMode="collectionModeData"
												v-if="collectionModeData?.id != 'language_review'"
												:inputProps="[
													{
														content: post?.mainOutcome.authorIdentifier,
														propName: 'other.authorIdentifier',
														inputType: 'select',
														selectProps: {
															optionValue: 'identifier',
															optionLabel: 'title',
															class: 'w-15rem',
															optionsCvKey: 'author',
														},
													},
												]"
												:href="post?._links?.mainOutcomeEdit?.href || ''"
												blockTitle="Edit author"
											>
												<div class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
											</InplaceEdit>
											<div v-else class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
										</div>
										<div v-if="post?.mainOutcome.leadText" class="relative py-3">
											<strong class="mb-4">{{ labels.leadText }}</strong>
											<div id="editLeadText" class="flex items-end relative">
												<InplaceEdit
													:collectionMode="collectionModeData"
													:enableCollapseSection="true"
													:extraContent="post?.mainOutcomeBl.leadText"
													:inputProps="[{ content: post?.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
													:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit leadtext" :showAssistant="true">
													<div v-html="post?.mainOutcome.leadText"></div>
												</InplaceEdit>
											</div>
										</div>

									</div>	
								</div>							
								<div :class="sectionLayoutClass">
									<div class="main-text relative">
										<div v-for="(section, index) in post?.mainOutcome.main_text" :key="index" >
											<InplaceEdit
												:collectionMode="collectionModeData"
												:enableCollapseSection="true"
												:extraContent="[
													post?.mainOutcomeBl?.main_text?.[index]?.heading ?? '',
													post?.mainOutcomeBl?.main_text?.[index]?.content ?? ''
												]"
												:inputProps="[
													{ content: section.heading, inputType: 'input', propName: 'heading' },
													{ content: section.content, inputType: 'editor', propName: 'content' },
												]"
												method="PUT"
												:href="section._links.self.href"
												blockTitle="Edit section"
												:showAssistant="true"
											>
												<div class="my-2">
													<div class="text-sm">
														<strong class="block text-gray-700">
															{{ section.heading }}
														</strong>
														<div v-html="section.content" class="text-gray-600"></div>
													</div>
												</div>
											</InplaceEdit>
											<div class="flex w-full flex-col">
												<template v-if="section.illustrations && section.illustrations.length > 0">
													<div
														v-for="(illustration, imageIndex) in section.illustrations"
														:key="`${index}-${imageIndex}-${illustration.imageSrc || illustration.imageSrcEdit || 'image'}`"
														class="flex align-items-center gap-4 my-4"
													>
														<InteractiveImage class="w-[270px] overflow-hidden" alt="Image" preview>
															<template #indicatoricon>
																<i class="tabler:eye w-8 h-8 text-white"></i>
															</template>

															<template #image>
															
																<img
																	v-if="(illustration.imageSrc || illustration.imageSrcEdit) && !hasSectionImageError(index, imageIndex)"
																	:src="illustration.imageSrc || illustration.imageSrcEdit"
																	alt="image"
																	@load="onSectionImageLoad(index, imageIndex)"
																	@error="onSectionImageError(index, imageIndex)"
																	class="transition-opacity duration-300 w-full h-auto max-w-[270px] object-contain"
																	:class="{ 'opacity-0': !isSectionImageLoaded(index, imageIndex) }"
																/>
																
																<div v-else class="text-gray-400 italic text-sm">No image available</div>
															</template>

															<template #preview="slotProps">
																<div class="p-5">
																	<img
																		v-if="illustration.imageSrc || illustration.imageSrcEdit"
																		:src="illustration.imageSrc || illustration.imageSrcEdit"
																		alt="preview"
																		class="mx-auto"
																		:style="slotProps.style"
																		@click="slotProps.onClick"
																	/>
																	<p class="text-sm italic text-white mt-8 text-left">
																		{{ illustration?.imageTitle || '' }}
																	</p>
																</div>
															</template>
														</InteractiveImage>
														<div class="rounded bg-primary-50/20 p-3 flex flex-col gap-2 flex-1">
															<div class="text-left text-sm">
																<strong>{{labels.titleLabel}}</strong> {{ illustration?.imageTitle || '' }}
															</div>
															<div class="text-left text-sm">
																<strong>{{labels.descriptionLabel}}</strong> {{ illustration?.imageDescription || '' }}
															</div>
															<div class="text-left text-sm">
																<strong>{{labels.copyrightLabel}}</strong> {{ illustration?.imageCopyright || '' }}
															</div>
														</div>
													</div>
												</template>
											</div>
										</div>
									</div>
									<div class="relative mt-3 py-4" v-if="post?.mainOutcome.references && post.mainOutcome.references.length > 0" >
										<h3 class="font-bold text-md mb-4">{{ labels.referenceslabel }}</h3>
										<!-- <EditButton
											v-if="collectionModeData?.editmode && collectionModeData?.id != 'language_review'"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/> -->

										<div id="references" class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div
														class="py-5 px-2 mx-4"
													>
														<ol class="list-decimal">
															<li
																v-for="(referenceItem, index) in post?.mainOutcome
																	.references"
																:key="index"
																class="text-sm"
															>
															<div class="flex items-center py-1">
																	<InplaceEdit
																		:collectionMode="collectionModeData"
																		:inputProp="
																			{
																				content: referenceItem,
																				propName: 'other',
																				removeProps: ['pdfLink', '_links'],
																				inputType: 'references',
																			}
																		"
																		method="PUT"
																		:href="referenceItem._links?.self.href"
																		:showSwitch="true"
																		blockTitle="Edit Refrence"
																	>
																	
																		<span v-if="referenceItem.journal">
																			{{ referenceItem.journal }}
																		</span>
																		<span v-if="referenceItem.year">
																			{{ referenceItem.year }},
																		</span>

																		<span
																			v-if="
																				referenceItem.nameDOI || referenceItem.linkDOI
																			"
																			class="font-semibold"
																		>
																			{{ referenceItem.nameDOI ? 'DOI:' : 'Link:' }}
																			<a
																				:href="
																					referenceItem.nameDOI
																						? `https://doi.org/${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				"
																				target="_blank"
																				class="text-primary"
																			>
																				{{
																					referenceItem.nameDOI
																						? `${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				}}
																			</a>
																		</span>
																		<span
																			v-if="
																				(referenceItem.nameDOI ||
																					referenceItem.linkDOI) &&
																				referenceItem.title
																			"
																			>,
																		</span>
																		<span
																			v-if="referenceItem.title"
																			class="ml-1 font-semibold"
																			>&laquo;{{ referenceItem.title }}&raquo;</span>
																	</InplaceEdit>
																	<a v-if="referenceItem?.pdfLink" @click.prevent="openModal(index)" class="btn btn-outline-dark px-1 py-0 cursor-pointer no-print">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a>
																	<!-- <a v-if="referenceItem?.pdfLink" @click="openModal" class="btn btn-outline-dark px-1 py-0 cursor-pointer"  		:href="`/example/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a> -->
																	<!-- <iframe class="pdfViewer w-100 h-100" style="" :src="`/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`"></iframe> -->

																</div>
															</li>
														</ol>
													</div>
													<!-- <div v-else class="p-5 bg-gray-100 flex items-center">
														<div class="text-center text-danger text-xs inline-flex mx-auto">
															<i class="tabler:info-triangle w-5 h-5 mr-2"></i>{{labels.noReference}}
														</div>
													</div> -->
												</div>
											</div>
										</div>
									</div>
									<!-- <div class="relative no-print">
										<RatingItems :jsonData="post" :feedback-url="computedFeedbackUrl" :selectedLanguage="currentLng" @open-postquiz="modalVisiblePostQuiz = true" :collectionMode="collectionModeData" />
									</div> -->
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useEventBus } from '@vueuse/core';
import axios from 'axios'
import ImageGallery from '../components/ImageGallery.vue';
import LanguageSwitcher from '../components/LanguageSwitcher.vue';
import PrintButton from '../components/PrintButton.vue';
import SoundPlayer from '../components/SoundPlayer.vue';
import RatingItems from '../components/RatingItems.vue';
import PostQuiz from '../components/PostQuiz.vue';
import EditButton from '../components/EditButton.vue';
import SliderPanel from '@/components/SidebarPanel/SidebarPanel.vue'
import { useAppConfig } from '@/composables/useAppConfig';
import { messages } from '@/assets/language';
import type { configCollectionMode, CVResponse, LanguageItem, Post, PostDetailsResponse } from '@/types';
import { DateTime } from 'luxon';
import InplaceEdit from '@/components/InplaceEdit/InplaceEdit.vue';
import { CVDataProvided } from '@/types/cvTypes';
import { useAppStore } from '@/stores/app-store'
import EwLoadingOverlay from '@/components/EwLoadingOverlay.vue';
import SmallSoundPlayer from '@/components/SmallSoundPlayer.vue';

const isImageLoaded = ref(false);
const isImageError = ref(false);
const sectionImageLoaded = ref<Record<string, boolean>>({});
const sectionImageError = ref<Record<string, boolean>>({});
const loading = ref( false );

const sectionImageStateKey = (sectionIndex: number, imageIndex: number): string => `${sectionIndex}-${imageIndex}`;

const isSectionImageLoaded = (sectionIndex: number, imageIndex: number): boolean =>
	Boolean(sectionImageLoaded.value[sectionImageStateKey(sectionIndex, imageIndex)]);

const hasSectionImageError = (sectionIndex: number, imageIndex: number): boolean =>
	Boolean(sectionImageError.value[sectionImageStateKey(sectionIndex, imageIndex)]);

const onSectionImageLoad = (sectionIndex: number, imageIndex: number): void => {
	const key = sectionImageStateKey(sectionIndex, imageIndex);
	sectionImageLoaded.value[key] = true;
	sectionImageError.value[key] = false;
};

const onSectionImageError = (sectionIndex: number, imageIndex: number): void => {
	const key = sectionImageStateKey(sectionIndex, imageIndex);
	sectionImageError.value[key] = true;
};

type MainTextIllustration = {
	imageSrc?: string;
	imageSrcEdit?: string;
	imageTitle?: string;
	imageDescription?: string;
	imageCopyright?: string;
};

const toFlatIllustrationList = (value: unknown): MainTextIllustration[] => {
	const output: MainTextIllustration[] = [];

	const collect = (entry: unknown): void => {
		if (Array.isArray(entry)) {
			entry.forEach(collect);
			return;
		}

		if (!entry || typeof entry !== 'object') {
			return;
		}

		const candidate = entry as MainTextIllustration;
		if (typeof candidate.imageSrc === 'string' || typeof candidate.imageSrcEdit === 'string') {
			output.push(candidate);
		}
	};

	collect(value);
	return output;
};

const normalizePostSectionIllustrations = (candidate: Post | null): Post | null => {
	if (!candidate?.mainOutcome?.main_text) {
		return candidate;
	}

	const normalizedMainText = candidate.mainOutcome.main_text.map((section) => {
		const normalizedIllustrations = toFlatIllustrationList((section as { illustrations?: unknown }).illustrations);

		return {
			...section,
			illustrations: normalizedIllustrations
		};
	});

	return {
		...candidate,
		mainOutcome: {
			...candidate.mainOutcome,
			main_text: normalizedMainText
		}
	} as Post;
};



const route = useRoute();
const router = useRouter();
const bus = useEventBus<Record<string, any>>('saved');
const { currentLng, currentCollectionMode, 	currentTestyourself, currentPAGE_REQ_ID } = useAppStore()


const AppConfig = useAppConfig();
const computedFeedbackUrl = computed(() => {
	const baseUrl = AppConfig.urls.feedback?.url ?? ""
	const id = post.value?.identifier ?? ""
	const packageLng = currentLng.value ?? ""
	const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
	const feedbacktype = collectionModeData.value?.feedbacktype ?? "AJS"
	const separator = baseUrl.includes("?") ? "&" : "?"
	return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}&feedbacktype=${feedbacktype}`
})

watch(currentLng, ()=>{
	fetchDataPost()
	
})
const languageList = computed(() => CVData.value?.data?.language ?? []);
const modalVisiblePostQuiz = ref(false);
const isModalPostQuiz = computed(() => AppConfig.urls.postquiz?.modal === true)

const showGallery = ref(false);


function onPropSaved(event: Record<string, any>) {
	console.log(event);
	fetchDataPost();
}

const unsubscribe = bus.on(onPropSaved);

const CVData = ref<CVResponse>({ data: {} });
provide(CVDataProvided, CVData);

// const selectedLanguage = computed( () => ( route.query.lng ) );
const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
});

const props = defineProps<{
  selectedLanguage?: string;
  enableCollapseSection: { type: Boolean, default: false },
}>();


// ✅ Funksion që kontrollon nëse duhet marrë nga mainOutcome apo mainOutcomeBl



const postId = (route.params.id as string) || null;


const post = ref<Post | null>(null);
const detailsContent = ref<HTMLElement | null>(null);
const collectionModeData = ref<configCollectionMode | null>(null);
const sectionLayoutClass = computed(() => {
	const layout = post.value?.mainOutcome?.sectionLayout;
	
	if (layout === 'oneCol') {
		return 'md:px-0 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1';
	}
	if (layout === 'twoCol') {
		return 'md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1';
	}

	// fallback për raste të tjera nëse ndonjëherë mungon vlera
	return 'md:px-0 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1';
});

const publishingDateFormated = computed(() => {
	const publishingDate = post.value?.mainOutcome.publishingDate;
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};
	const formatDate = (date: Date) => {
		return new Intl.DateTimeFormat('en-GB', options).format(date);
	};
	if (!publishingDate) {
		return formatDate(new Date());
	}
	const dateTime = DateTime.fromISO(publishingDate);
	if (!dateTime.isValid) {
		return formatDate(new Date());
	}
	return formatDate(dateTime.toJSDate());
});

const fetchDataPost = async () => {
  try {
    loading.value = true;
	sectionImageLoaded.value = {};
	sectionImageError.value = {};

    const url = AppConfig.urls.getList;
    if (!url) throw new Error('getList URL missing');

    const params: Record<string, any> = {
      package_id: route.query.package_id,
      mode: 'details',
      lng: currentLng.value,
      json: 'y', // nëse backend e kërkon
      'collection-mode': currentCollectionMode.value,
      testYourself: currentTestyourself.value,
      PAGE_REQ_ID: currentPAGE_REQ_ID.value,
      offset: 0,
      limit: 15,
      'latest-days': 14
    };

    const response = await axios.get<PostDetailsResponse>(url, {
      params,
      headers: { Accept: 'application/json' }
    });

    const data = response.data?.data ?? null;

    if (data && postId) {
      const selectedPost = Array.isArray(data)
        ? data.find((p) => p.identifier === postId) ?? null
        : data;
      post.value = normalizePostSectionIllustrations(selectedPost);
    } else {
      post.value = null;
    }

    CVData.value = response.data.CV;
    collectionModeData.value = response.data.config ?? null;

  } catch (error) {
    console.error('Failed to fetch details:', error);
  } finally {
    loading.value = false;
  }
};

const refreshListEvent = useEventBus('refresh-listview')
const stopListening = refreshListEvent.on(() => {
  refresh()
})

const refresh = () => {
  fetchDataPost();
};

const openModal = (index: number) => {
  // Merr PDF linkun bazuar në index
  const pdfLink = post.value?.mainOutcome.references[index]?.pdfLink;

  if (!pdfLink) {
    console.error('PDF Link is not available.');
    return;
  }

  // Ndërto URL-në për iframe
  const viewerUrl = `/example/pdfjs/web/viewer.html?file=${encodeURIComponent(pdfLink)}`;

  // Hap modalin duke përdorur Bootstrap API
  const modal = new bootstrap.Modal(document.getElementById('pdfViewer') as HTMLElement);
  modal.show();

  // Vendos URL-në në iframe
  const iframe = document.getElementById('pdfIframe') as HTMLIFrameElement;
  if (iframe) {
    iframe.src = viewerUrl; // Vendos URL-në e ndërtuar
  }
};

onBeforeUnmount( () => {
	unsubscribe();
	document.removeEventListener('refreshList', refresh);
	stopListening(); 

} )


onMounted(() => {
	  console.log('DETAILS ID:', route.params.id)

	fetchDataPost();
});




</script>
